import { render } from "./EligibilityListTab.vue?vue&type=template&id=2a36078a"
import script from "./EligibilityListTab.vue?vue&type=script&lang=js"
export * from "./EligibilityListTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__